import React, { useState } from "react"
import Helmet from "react-helmet"
import { graphql } from 'gatsby'
import Layout from "../components/layout"

const CONTACT_EMAIL = "yqxxxnaxr1109@gmail.com"
const CONTACT_SUBJECT = "KenRp Blog contact"

const CONTACT_ENDPOINT = `https://formsubmit.co/ajax/${CONTACT_EMAIL}`

const handleContactSubmit = async (event, setSubmitState) => {
  event.preventDefault()

  const form = event.currentTarget
  const formData = new FormData(form)

  setSubmitState({ type: "pending", message: "Sending..." })

  try {
    const response = await fetch(CONTACT_ENDPOINT, {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
      body: formData,
    })

    if (!response.ok) {
      throw new Error("Failed to submit contact form")
    }

    form.reset()
    setSubmitState({
      type: "success",
      message: "送信しました。Contactページに戻りました。",
    })
  } catch (error) {
    setSubmitState({
      type: "error",
      message: "送信できませんでした。時間をおいて再度お試しください。",
    })
  }
}

const ContactPage = ({
  data: {
    site
  },
}) => {
  const [submitState, setSubmitState] = useState(null)

  return (
    <Layout>
      <Helmet>
        <title>お問い合わせ | {site.siteMetadata.title}</title>
        <meta name="description" content="KenRp Blogへの連絡先ページです。" />
      </Helmet>
      <div className="two-grids -contact">
        <div className="post-thumbnail" style={{backgroundImage: `url('/kenRp-blog/assets/alexander-andrews-HgUDpaGPTEA-unsplash.jpg')`, marginBottom: 0}}>
          <h1 className="post-title">お問い合わせ</h1>
          <p>記事への質問、技術メモの相談、制作物についての連絡はこちらから。</p>
        </div>
        <div>
          <section className="form-container contact-panel">
            <p className="eyebrow">Contact</p>
            <h2>GitHub Issuesで連絡できます</h2>
            <p>
              記事への質問やサイトについての連絡は、GitHub Issuesに投稿してください。内容を公開メモとして残せるので、あとから経緯を追いやすくなります。
            </p>
            <div className="button-group">
              <a className="button -primary" href="https://github.com/kenRp01/kenRp01.github.io/issues" target="_blank" rel="noreferrer">
                Open Issue
              </a>
              <a className="button" href="https://github.com/kenRp01" target="_blank" rel="noreferrer">
                GitHub Profile
              </a>
            </div>
          </section>
          <section className="form-container contact-form">
            <p className="eyebrow">Contact form</p>
            <h2>問い合わせフォーム</h2>
            <p>
              公開Issueにしづらい内容はこちらから送れます。送信後もこのページに戻ります。
            </p>
            <form action={CONTACT_ENDPOINT} method="POST" onSubmit={event => handleContactSubmit(event, setSubmitState)}>
              <input type="hidden" name="_subject" value={CONTACT_SUBJECT} />
              <input type="hidden" name="_template" value="table" />
              <label htmlFor="contact-name">Name</label>
              <input id="contact-name" type="text" name="name" autoComplete="name" required />
              <label htmlFor="contact-email">Email</label>
              <input id="contact-email" type="email" name="email" autoComplete="email" required />
              <label htmlFor="contact-message">Message</label>
              <textarea id="contact-message" name="message" required />
              <button className="button -primary" type="submit" disabled={submitState && submitState.type === "pending"}>
                {submitState && submitState.type === "pending" ? "Sending..." : "Send message"}
              </button>
            </form>
            {submitState && (
              <p className={`form-status -${submitState.type}`} role="status">
                {submitState.message}
              </p>
            )}
          </section>
        </div>
      </div>
    </Layout>
  )
}
export default ContactPage
export const pageQuery = graphql`
  query ContactPageQuery{
    site {
      siteMetadata {
        title
        description
      }
    }
  }
`
